import {validatenull} from './validate'
import {dicXsmAbleProduct} from './dicList'
import {MessageBox} from 'element-ui'

export function random4() {
	return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}

export function random8() {
	return `${random4()}-${random4()}-${random4()}`
}

export function getPageId() {
	return (
		new Date().getTime() + '-' + random4() + '-' + random4() + '-' + random4() + '-' + random4() + random4() + random4()
	)
}

//转换区域
export function convertAreaCode(areaCode = '') {
	if (areaCode !== '') {
		return [`${areaCode.substr(0, 2)}0000`, `${areaCode.substr(0, 4)}00`, areaCode]
	}
	return []
}

//处理请求头clearcode
// 1清工号
// 2清地区
// 99清全部
export function dealClearCode(insureType = -1, store) {
	//获取存储的主渠道数据
	let headers = {}
	try {
		//解构
		let {userInfo: {channelObj} = {}, userInfoMain} = store.state.user || {}
		let {mainChannelData} = store.state.common || {}
		let channelTempObj = channelObj || mainChannelData || userInfoMain
		console.log('channelTempObj------->', channelTempObj)
		let {classify = -1, groupCode = -1} = channelTempObj || {}
		console.error('dealClearCode-----', insureType, classify, groupCode)
		let tempClearCodeData = {
			insureType,
			classify,
			groupCode,
			tempInsureTypes: [],
		}
		if (insureType === -1 || classify !== 3) {
			headers.clear_code_temp = JSON.stringify(tempClearCodeData)
			return headers
		}
		let tempInsureTypes = dicXsmAbleProduct[groupCode + ''] || []
		let tempIndex = tempInsureTypes.findIndex((itemData) => itemData == insureType)
		if (tempIndex === -1) {
			//说明投的产品是不属于自己公司的，则需要清理工号
			headers.clearcode = 99
		}
		tempClearCodeData.tempInsureTypes = tempInsureTypes
		//请求头加数据
		headers.clear_code_temp = JSON.stringify(tempClearCodeData)
		console.error(
			'判断是否需要清理工号！------------',
			headers.clearcode === 99 ? '清理工号' : '不清理工号',
			tempInsureTypes,
		)
		return headers
	} catch (error) {
		console.log('commonUtils-------dealClearCode>', error)
		return headers
	}
}

export function clearPLabel(content = '') {
	if (content !== '') {
		return content.replace('<p>', '').replace('</p>', '')
	}
}

//清除空数据，
export function clearEmptyData(data = {}) {
	if (validatenull(data)) {
		return data
	}
	for (let dataKey in data) {
		//带$的删除
		if (dataKey.includes('$')) {
			delete data[dataKey]
		}
		if (validatenull(data[dataKey])) {
			delete data[dataKey]
		}
	}
	return data
}

//通过身份证号 获取年龄
export function getAgeByCardNo(cardNo = '') {
	let myDate = new Date()
	let month = myDate.getMonth() + 1
	let day = myDate.getDate()
	let age = myDate.getFullYear() - parseInt(cardNo.substring(6, 10)) - 1
	let chaMonth = parseInt(cardNo.substring(10, 12))
	if (chaMonth < month || (chaMonth === month && parseInt(cardNo.substring(12, 14)) <= day)) {
		age++
	}
	return age
}

//有些参数是不需要校验的！
export function isAllDataReady(tempData) {
	let isAllData = true
	for (let tempPlanDataKey in tempData) {
		if (tempPlanDataKey !== 'expiryDate' && validatenull(tempData[tempPlanDataKey])) {
			console.log('isAllDataReady----------', tempPlanDataKey, validatenull(tempData[tempPlanDataKey]))
			return false
		}
	}
	return isAllData
}

//获取浏览器版本号
export function getChromeVersion() {
	let arr = navigator.userAgent.split(' ') || []
	//默认为100
	let tempVersion = 100
	let chromeVersionContent = ''
	for (let i = 0; i < arr.length; i++) {
		if (/chrome/i.test(arr[i])) {
			chromeVersionContent = arr[i]
		}
	}
	if (chromeVersionContent && chromeVersionContent.includes('/') && chromeVersionContent.includes('.')) {
		tempVersion = Number(chromeVersionContent.split('/')[1].split('.')[0])
	}
	console.log('getChromeVersion------', chromeVersionContent, tempVersion)
	return tempVersion
}

//区分不同浏览器内核
export function getBrowserType() {
	let userAgent = navigator.userAgent //取得浏览器的userAgent字符串
	userAgent = userAgent.toLowerCase()
	console.log(userAgent.indexOf('edg') > -1 || userAgent.indexOf('chrome') > -1, '浏览器内核--------', userAgent)
	return userAgent.indexOf('edg') > -1 || userAgent.indexOf('chrome') > -1
}

//清除html
export function clearHtml(content = '') {
	if (content && (content.includes('<p') || content.includes('style='))) {
		content = content.replace(/<[^>]+>/g, '')
	}
	return content
}
